<template>
  <d-modal
    class="modal-big"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('potentialCustomers.addNewContact') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        v-if="allDataLoaded && !loadError"
        ref="contact-new-form" tag="form">
        <div class="form-group">
          <label>
            {{ $t('customer.contact.contactDate') }}:
          </label>

          <validation-provider
            rules="required"
            name="date"
            v-slot="{ errors }">
            <d-datepicker
              v-model="date"
              :monday-first="true"
              format="yyyy-MM-dd"
              :placeholder="$t('ui.chooseDate')"
              :disabled-dates="futureDates"
              :language="translationsForDatePicker" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>

        <div class="form-group">
          <label class="d-block">
            {{ $t('customer.contact.contactType') }}:
          </label>
          <d-form-checkbox
            v-for="(contactType, index) of contactTypes"
            :key="'contact-type-checkbox-' + index"
            inline
            v-model="types"
            :value="contactType.type">
            {{ contactType.name }}
          </d-form-checkbox>
        </div>

        <div class="form-group">
          <label for="name">
            {{ $t('customer.contact.descriptionOptional') }}:
          </label>

          <d-textarea
            :value.prop="description"
            v-model="description" />
        </div>
      </validation-observer>

      <div v-if="!allDataLoaded && !loadError" class="pb-3 pt-3 text-center overlay-loading">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        :disabled="saveInProgress"
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        <div
          v-if="saveInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        <template v-if="!saveInProgress">
          {{ $t('ui.saveChanges') }}
        </template>
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import datepickerTranslations from './../../data/datepicker-translations.js';
import FormUtils from './../../utils/FormUtils.js';
import getPrefferedLanguage from './../../utils/i18nUtils.js';

export default {
  name: 'potential-customer-new-contact-popup',
  props: [
    'potentialCustomerID'
  ],
  computed: {
    allDataLoaded () {
      return this.loadedTypes;
    },
    translationsForDatePicker () {
      return datepickerTranslations[getPrefferedLanguage()];
    },
    futureDates () {
      return {
        from: new Date()
      };
    }
  },
  data() {
    return {
      date: new Date(),
      types: ['PHONE'],
      description: '',
      saveInProgress: false,
      contactTypes: [],
      loadedTypes: false,
      loadError: false
    };
  },
  mounted () {
    this.loadAdditionalData();
  },
  methods: {
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customer-contact-types/items',
        loadedKey: 'loadedTypes',
        outputKey: 'contactTypes',
        errorKey: 'loadError'
      });
    },
    handleClose () {
      this.$bus.$emit('close-potential-customer-new-contact-popup');
    },
    validateForm () {
      FormUtils.validate(this.$refs['contact-new-form'], this.submitForm);
    },
    submitForm () {
      this.saveInProgress = true;

      let formDataToSend = {
        date: [this.date.getFullYear(), this.date.getMonth() + 1, this.date.getDate()].map(n => n < 10 ? '0' + n : n).join('-'),
        types: this.types,
        description: this.description,
        potential_customer_id: this.potentialCustomerID
      };

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/potential-customers/contacts/store',
        formData: formDataToSend,
        successTitle: this.$t('customer.contact.saveContactSuccessTitle'),
        successText: this.$t('customer.contact.saveContactSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('customer.contact.saveContactErrorText'),
        successAction: () => {
          this.saveInProgress = false;
          this.$bus.$emit('potential-customer-contacts-reload-needed');
          this.handleClose();
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
};
</script>
